import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'xilo-mono-form-viewer-grid-row',
  templateUrl: './row.component.html',
  styleUrls: ['../../../assets/custom-theme.scss', './row.component.scss'],
})
export class CustomGridRowComponent extends FieldArrayType implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    console.log(this.field);
  }


}
